function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.5 12.5L8.75 7 .5 1.5l1-1.5L12 7 1.5 14l-1-1.5z",
  fill: "#0D5A91"
});

var SvgBespokenGreaterThan = function SvgBespokenGreaterThan(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgBespokenGreaterThan;